import * as ActionTypes from "./actionTypes";
import * as Actions from "./action";
import { PayableContractError, PayableContractErrorOrigin } from "./types";
import { ErrorAction } from "src/common/apiLoader/state/actions";
import { parseDataKey } from "src/common/util";
import { PayableContract } from "src/common/models/payableContract";

export interface PayableContractState {
    error?: PayableContractError | undefined
    payableContracts?: PayableContract[]
    createPayableContractSuccess: boolean
    currentPayableContract?: PayableContract
    updatePayableContractSuccess: boolean
}

const initialState: PayableContractState = {
    createPayableContractSuccess: false,
    updatePayableContractSuccess: false,
}

const payableContractReducer = (state: PayableContractState = initialState, action: any): PayableContractState => {
    switch (action.type) {
        case ActionTypes.GET_PAYABLE_CONTRACTS_API: {
            return {
                ...state,
                error: undefined,
            }
        }
        case ActionTypes.GET_PAYABLE_CONTRACTS_API_SUCCESS: {
            const successAction = action as Actions.GetPayableContractsSuccessAction

            return {
                ...state,
                payableContracts: parseDataKey(successAction.payableContracts),
            }
        }
        case ActionTypes.GET_PAYABLE_CONTRACTS_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: PayableContractErrorOrigin.GET_PAYABLE_CONTRACTS,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.CREATE_PAYABLE_CONTRACT_API: {
            return {
                ...state,
                error: undefined,
                createPayableContractSuccess: false,
            }
        }
        case ActionTypes.CREATE_PAYABLE_CONTRACT_API_SUCCESS: {
            return {
                ...state,
                createPayableContractSuccess: true,
            }
        }
        case ActionTypes.CREATE_PAYABLE_CONTRACT_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: PayableContractErrorOrigin.CREATE_PAYABLE_CONTRACT,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_PAYABLE_CONTRACT_BY_ID_API: {
            return {
                ...state,
                currentPayableContract: undefined,
            }
        }
        case ActionTypes.GET_PAYABLE_CONTRACT_BY_ID_API_SUCCESS: {
            const successAction = action as Actions.GetPayableContractByIdSuccessAction

            return {
                ...state,
                currentPayableContract: successAction.payableContract,
            }
        }
        case ActionTypes.GET_PAYABLE_CONTRACT_BY_ID_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: PayableContractErrorOrigin.GET_PAYABLE_CONTRACT_BY_ID,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.CLEAN_CURRENT_PAYABLE_CONTRACT: {
            return {
                ...state,
                currentPayableContract: undefined,
            }
        }
        case ActionTypes.UPDATE_PAYABLE_CONTRACT_API: {
            return {
                ...state,
                error: undefined,
                updatePayableContractSuccess: false,
            }
        }
        case ActionTypes.UPDATE_PAYABLE_CONTRACT_API_SUCCESS: {
            return {
                ...state,
                updatePayableContractSuccess: true,
            }
        }
        case ActionTypes.UPDATE_PAYABLE_CONTRACT_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: PayableContractErrorOrigin.UPDATE_PAYABLE_CONTRACT,
                    detail: errorAction.error,
                },
            }
        }
    }
    return state;
};

export default payableContractReducer;